"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaFeedDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class SocialMediaFeedDto {
    constructor(params) {
        this.site = "";
        this.url = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.site = params.site;
        this.url = params.url;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.SocialMediaFeedDto = SocialMediaFeedDto;
//# sourceMappingURL=SocialMediaFeedDto.js.map